import { useMemo, useState } from 'react';
import { Box, Chip, Stack, TextField, Typography } from '@mui/material';

function normalizeTag(s) {
  return String(s || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');
}

export default function TagsEditor({ saving, tags, onChangeTags }) {
  const [input, setInput] = useState('');

  const normalizedTags = useMemo(() => {
    const arr = Array.isArray(tags) ? tags : [];
    // normalize + unique
    const set = new Set(arr.map(normalizeTag).filter(Boolean));
    return Array.from(set);
  }, [tags]);

  const addTag = () => {
    const t = normalizeTag(input);
    if (!t) return;
    if (normalizedTags.includes(t)) {
      setInput('');
      return;
    }
    onChangeTags([...normalizedTags, t]);
    setInput('');
  };

  const removeTag = (t) => {
    onChangeTags(normalizedTags.filter((x) => x !== t));
  };

  return (
    <Box>
      <Typography variant="body2" sx={{ mb: 0.5 }}>
        Tags
      </Typography>

      <TextField
        size="small"
        label="Type tag and press Enter"
        value={input}
        disabled={saving}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            addTag();
          }
        }}
        fullWidth
      />

      {normalizedTags.length > 0 && (
        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{ mt: 1 }}>
          {normalizedTags.map((t) => (
            <Chip
              key={t}
              label={t}
              onDelete={saving ? undefined : () => removeTag(t)}
              size="small"
              variant="outlined"
            />
          ))}
        </Stack>
      )}
    </Box>
  );
}